"use client";

export const runtime = "edge";

import { useEffect } from "react";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getInformationList } from "@/store/controller/information.controller";
import { formatDate } from "../../components/landing/format";
import { getCategoryColor } from "../../components/landing/theme";

export default function BeritaListPage() {
  const dispatch = useAppDispatch();
  const information = useAppSelector((state) => state.information.list);
  const news = information.filter((item) => item.type === "berita");

  useEffect(() => {
    dispatch(getInformationList({ type: "berita", limit: 100 }));
  }, [dispatch]);

  return (
    <div className="pt-24 sm:pt-28">
      <div className="bg-green-800 py-12 sm:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-green-300 text-sm mb-4">
            <Link href="/" className="hover:text-white transition-colors">
              Beranda
            </Link>
            <ChevronRight size={14} />
            <span className="text-white">Berita</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">Berita</h1>
          <p className="text-green-200 max-w-xl">Informasi terkini seputar kegiatan dan prestasi SMAIT Ihsanul Fikri.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((newsItem) => (
            <Link
              key={newsItem.id}
              href={`/berita/${newsItem.id}`}
              className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-48 overflow-hidden bg-gray-100">
                {newsItem.image && (
                  <img
                    src={newsItem.image}
                    alt={newsItem.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between mb-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${getCategoryColor(newsItem.category_id)}`}>
                    {newsItem.category?.name}
                  </span>
                  <span className="text-gray-400 text-xs">{formatDate(newsItem.date)}</span>
                </div>
                <h3 className="font-bold text-gray-900 leading-snug mb-2 text-sm group-hover:text-green-700 transition-colors">
                  {newsItem.title}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed line-clamp-2">{newsItem.excerpt || newsItem.content}</p>
                <div className="mt-4 flex items-center gap-1 text-green-700 text-xs font-semibold group-hover:gap-2 transition-all">
                  Selengkapnya
                  <ChevronRight size={13} />
                </div>
              </div>
            </Link>
          ))}
        </div>
        {news.length === 0 && <p className="text-center text-gray-400">Belum ada berita.</p>}
      </div>
    </div>
  );
}
